var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config_item"},[(_vm.field)?_c('span',{staticClass:"item_field"},[_vm._v(_vm._s(_vm.field)+"：")]):_vm._e(),_c('div',{staticClass:"item_content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }